/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-26 13:34:21
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-02-18 10:38:13
 */
import type { LocationShowCodeEnum, TemplateTypeCode, TopicBaseResponse, TopicSwiperResponse, TopicTemplateBase, TopicTemplateBaseParams, TopicTemplatePage, TopicTemplatePageParams } from './types'
import type { FetchResponseType, PaginationParams, PaginationResponse } from '@/server/request/types'
import { useApiFetch } from '@/server/request'

/**
 * 专题基本信息
 * @returns promise<TopicBaseResponse>
 */
export function topicBaseDetailApi(id: string) {
  return useApiFetch<FetchResponseType<TopicBaseResponse>>('/webportal/base/topic/detail', { method: 'GET', params: { topicId: id } })
}
/**
 * 专题轮播图/文字链
 * 支持:模板1/模板2/模板3
 */
export async function topicSwiperApi(id: string) {
  return useApiFetch<FetchResponseType<TopicSwiperResponse>>('/webportal/base/topic/templateBannerData', { method: 'GET', params: { topicId: id } })
}

/**
 * 模板的基础数据
 * 模板1(newReport最新报道/knowledgeExtend知识扩展/pastTopics往期专题);
 * 模块2(top红黑榜资讯/pastTopics往期专题);
 * 模板3(pastTopics往期专题/otherArticle其他资讯)
 */
export function topicTemplateBaseDataApi(params: TopicTemplateBaseParams) {
  return useApiFetch<FetchResponseType<TopicTemplateBase<typeof params.templateTypeCode>>>('/webportal/base/topic/templateBaseData', { method: 'GET', params })
}

/**
 * 模板的分页数据
 * 模板1(资讯模块1/资讯模块2...);
 * 模块2(投诉1/投诉2...);
 * 模板3(资讯模块)
 */
export function topicTemplatePageDataApi<T extends TemplateTypeCode, U extends keyof LocationShowCodeEnum<T>>(params: TopicTemplatePageParams<T, U>) {
  return useApiFetch<FetchResponseType<PaginationResponse<TopicTemplatePage<T>[]>>>('/webportal/base/topic/templatePageData', { method: 'GET', params })
}
